  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  const CARD_SWATCH_WIDTHS = [375, 550, 750, 1100, 1500, 1700, 1900];

  // Preview behaviour — see the two open decisions in the notes.
  const CARD_SWATCH_MOVES_SELECTION = true;
  const CARD_SWATCH_UPDATES_LINK = true;

  const getCardColorMedia = (wrapper) => {
    if (!wrapper.colorMediaMap) {
      try {
        wrapper.colorMediaMap = JSON.parse(wrapper.dataset.colorMedia || '{}');
      } catch (error) {
        wrapper.colorMediaMap = {};
      }
    }
    return wrapper.colorMediaMap;
  }

  const previewCardColor = (input) => {
    const wrapper = input.closest('.js-color-swatches-wrapper');
    if (!wrapper || !wrapper.dataset.colorMedia) return;
    if (wrapper.dataset.colorValue === input.value) return;

    const primaryImage = wrapper.querySelector('.media--first');
    const image = getCardColorMedia(wrapper)[input.value];
    if (!primaryImage || !image) return;

    // image.src is protocol-relative from Liquid's image_url, so give URL a base.
    const src = new URL(image.src, window.location.href);
    src.searchParams.set('width', '1920');

    // Mutated in place: sizes / loading / width / class / style survive untouched.
    primaryImage.srcset = generateSrcset({ src: src.href, width: image.w }, CARD_SWATCH_WIDTHS);
    primaryImage.src = src.href;
    primaryImage.alt = image.alt;
    if (image.fp) primaryImage.style.objectPosition = image.fp;
    wrapper.dataset.colorValue = input.value;

    if (CARD_SWATCH_UPDATES_LINK && input.dataset.variantLink) {
      wrapper.querySelectorAll('.js-color-swatches-link, .card__title a').forEach((link) => {
        link.setAttribute('href', input.dataset.variantLink);
      });
    }

    if (CARD_SWATCH_MOVES_SELECTION && !input.checked) {
      input.checked = true;
    }
  }

  let cardSwatchesBound = false;

  const checkSwatches = () => {
    // Delegated from document, so section renders / facet updates / load-more
    // need no re-binding. Guarded because colorSwatches() is re-called by
    // facets.js, load-more.js and predictive-search.js.
    if (cardSwatchesBound) return;
    cardSwatchesBound = true;

    const onSwatch = (event) => {
      const label = event.target.closest('.js-color-swatches .first_label');
      if (!label) return;
      const input = label.querySelector('input[type="radio"]');
      if (input) previewCardColor(input);
    }

    document.addEventListener('mouseover', onSwatch);  // pointer
    document.addEventListener('focusin', onSwatch);    // keyboard
    document.addEventListener('change', onSwatch);     // tap / arrow keys
  }


  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

(function () {
  colorSwatches();
})()